<template>
    <div class="wrapper h-[300px] lg:h-[400px] bg-slate-200 text-white px-8 md:px-20 items-center">
        <div class="h-full grid content-center space-y-4">
            <div class="uppercase font-bold text-xl">a place for you</div> 
            <div class="uppercase font-black text-4xl w-full md:w-96 head">Become a part of the family</div>
            <div class="max-w-fit">
                <RouterLink to="contact">
                    <SecondaryButton content="contact us"/>
                </RouterLink>
            </div>
        </div>
    </div>
</template>

<script setup>
import SecondaryButton from './SecondaryButton.vue';
</script>

<style scoped>
.wrapper{
    background: linear-gradient(rgb(0, 0, 0, 0.8), rgb(0, 0, 0, 0.2)), url('../assets/images/family.jpg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
</style>